import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, vModelSelect as _vModelSelect, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1eaec8fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-edit-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = {
  key: 0,
  class: "line1"
}
const _hoisted_4 = {
  key: 1,
  class: "line1"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line2" }, "Bank", -1))
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "bank-account"
}
const _hoisted_10 = { class: "ls-form" }
const _hoisted_11 = { class: "body-line-1" }
const _hoisted_12 = { class: "input-box-1 mr-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Search bank", -1))
const _hoisted_14 = {
  class: "autocomplete",
  style: {"flex":"0 0 100%"}
}
const _hoisted_15 = { class: "icon-hm" }
const _hoisted_16 = {
  key: 0,
  class: "fal fa-spinner fa-spin fa-lg"
}
const _hoisted_17 = {
  key: 1,
  class: "fal fa-search fa-lg"
}
const _hoisted_18 = {
  id: "autocomplete-results",
  class: "autocomplete-results"
}
const _hoisted_19 = ["innerHTML", "onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("fieldset", null, null, -1))
const _hoisted_21 = { class: "body-line-1" }
const _hoisted_22 = { class: "input-box-1 mr-4" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "BSB No. *", -1))
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "input-box-2" }
const _hoisted_26 = { class: "input-box" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Bank *", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "body-line-2" }
const _hoisted_30 = { class: "mr-4" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Branch *", -1))
const _hoisted_32 = ["value"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Account No. *", -1))
const _hoisted_34 = { class: "body-line-3" }
const _hoisted_35 = { class: "mr-4" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Account Name *", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Date Opened *", -1))
const _hoisted_38 = { class: "input-box" }
const _hoisted_39 = { class: "date-picker" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-calendar-check" }, null, -1))
const _hoisted_41 = {
  key: 0,
  class: "body-line-4"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Date Closed", -1))
const _hoisted_43 = { class: "input-box" }
const _hoisted_44 = { class: "date-picker" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-calendar-check" }, null, -1))
const _hoisted_46 = {
  key: 1,
  class: "general-acc-sys"
}
const _hoisted_47 = { class: "ls-form" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "General accounting system", -1))
const _hoisted_49 = { class: "input-box" }
const _hoisted_50 = { class: "select mb-4" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: null
}, "- Please select -", -1))
const _hoisted_52 = ["value"]
const _hoisted_53 = { class: "controls mt-4" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = ["disabled"]
const _hoisted_56 = {
  key: 2,
  class: "row mt-2 ml-2"
}
const _hoisted_57 = { class: "reset-filter" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "DELETE ALERT", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Are you sure you want to delete the bank?", -1))

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_v3_date_picker = _resolveComponent("v3-date-picker")
  const _component_ModalBox = _resolveComponent("ModalBox")
  const _component_AlertBox = _resolveComponent("AlertBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[13] || (_cache[13] = $event => (_ctx.cancelClicked())),
      mostScreen: true
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.isEdit)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Add " + _toDisplayString(_ctx.headingName), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, "Edit " + _toDisplayString(_ctx.headingName), 1)),
          _hoisted_5
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.isLoadingData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_LoadingIndicator)
              ]))
            : (_ctx.errorLoadingData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_ErrorIndicator)
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_ctx.bankAcct.accountType != null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("form", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("fieldset", _hoisted_12, [
                              _hoisted_13,
                              _createElementVNode("div", _hoisted_14, [
                                _withDirectives(_createElementVNode("input", {
                                  onKeydown: [
                                    _cache[0] || (_cache[0] = _withKeys((...args) => (_ctx.onArrowDown && _ctx.onArrowDown(...args)), ["down"])),
                                    _cache[1] || (_cache[1] = _withKeys((...args) => (_ctx.onArrowUp && _ctx.onArrowUp(...args)), ["up"])),
                                    _cache[2] || (_cache[2] = _withKeys((...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
                                  ],
                                  class: "searchField",
                                  type: "text",
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.search) = $event)),
                                  placeholder: "Search bank name"
                                }, null, 544), [
                                  [_vModelText, _ctx.search]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "hidden",
                                  id: "bank",
                                  name: "bank",
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.selectedBank) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.selectedBank]
                                ]),
                                _createElementVNode("span", _hoisted_15, [
                                  (_ctx.isSearching)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                                    : (_openBlock(), _createElementBlock("i", _hoisted_17))
                                ]),
                                _withDirectives(_createElementVNode("ul", _hoisted_18, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bankList, (bank, i) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: i,
                                      class: _normalizeClass(["autocomplete-result", { 'is-active': i === _ctx.arrowCounter }]),
                                      innerHTML: _ctx.highlightWord(bank.bsb + ' - ' + bank.bankName + ' ' + bank.branchName),
                                      onClick: _withModifiers($event => (_ctx.selectBank(bank)), ["prevent"])
                                    }, null, 10, _hoisted_19))
                                  }), 128))
                                ], 512), [
                                  [_vShow, _ctx.isOpen]
                                ])
                              ])
                            ]),
                            _hoisted_20
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("fieldset", _hoisted_22, [
                              _hoisted_23,
                              _createElementVNode("input", {
                                type: "text",
                                maxlength: "200",
                                value: _ctx.selectedBank?.bsb,
                                disabled: ""
                              }, null, 8, _hoisted_24)
                            ]),
                            _createElementVNode("fieldset", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _hoisted_27,
                                _createElementVNode("input", {
                                  type: "text",
                                  maxlength: "200",
                                  value: _ctx.selectedBank?.bankName,
                                  disabled: ""
                                }, null, 8, _hoisted_28)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("fieldset", _hoisted_30, [
                              _hoisted_31,
                              _createElementVNode("input", {
                                type: "text",
                                maxlength: "200",
                                value: _ctx.selectedBank?.branchName,
                                disabled: ""
                              }, null, 8, _hoisted_32)
                            ]),
                            _createElementVNode("fieldset", null, [
                              _hoisted_33,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "200",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.formData.accountNo) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.formData.accountNo]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("fieldset", _hoisted_35, [
                              _hoisted_36,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "200",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.formData.name) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.formData.name]
                              ])
                            ]),
                            _createElementVNode("fieldset", null, [
                              _hoisted_37,
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                  _createVNode(_component_v3_date_picker, {
                                    class: "v3-date-picker",
                                    modelValue: _ctx.dateOpened,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.dateOpened) = $event)),
                                    style: {"padding":"1em"},
                                    inputFormat: "dd-MM-yyyy"
                                  }, null, 8, ["modelValue"]),
                                  _hoisted_40
                                ])
                              ])
                            ])
                          ]),
                          (_ctx.isEdit)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                _createElementVNode("fieldset", null, [
                                  _hoisted_42,
                                  _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("div", _hoisted_44, [
                                      _createVNode(_component_v3_date_picker, {
                                        class: "v3-date-picker",
                                        lowerLimit: _ctx.dateOpened,
                                        modelValue: _ctx.dateClosed,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.dateClosed) = $event)),
                                        style: {"padding":"1em"},
                                        inputFormat: "dd-MM-yyyy"
                                      }, null, 8, ["lowerLimit", "modelValue"]),
                                      _hoisted_45
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("form", _hoisted_47, [
                          _createElementVNode("fieldset", null, [
                            _hoisted_48,
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.selectedAccountingApp) = $event))
                                }, [
                                  _hoisted_51,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountingApps, (acctApp) => {
                                    return (_openBlock(), _createElementBlock("option", { value: acctApp }, _toDisplayString(acctApp.name), 9, _hoisted_52))
                                  }), 256))
                                ], 512), [
                                  [_vModelSelect, _ctx.selectedAccountingApp]
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("button", {
                      class: "btn btn-default ml-1",
                      disabled: _ctx.submitting,
                      onClick: _cache[10] || (_cache[10] = _withModifiers($event => (_ctx.cancelClicked()), ["prevent","stop"]))
                    }, " Back ", 8, _hoisted_54),
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      disabled: _ctx.submitting || !(_ctx.isFormDirty && _ctx.validForm),
                      onClick: _cache[11] || (_cache[11] = _withModifiers($event => (_ctx.saveDetails()), ["prevent","stop"]))
                    }, _toDisplayString(_ctx.isEdit || _ctx.bankAcct.accountType == null ? 'Save': 'Add'), 9, _hoisted_55),
                    (_ctx.submitting)
                      ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                          key: 0,
                          class: "loading-indicator",
                          showLoadingText: false
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.isEdit && (_ctx.formData.accountTypeId == 1 || _ctx.formData.accountTypeId == 2))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _createTextVNode(" Or "),
                          _createElementVNode("a", {
                            class: "link2",
                            onClick: _cache[12] || (_cache[12] = (...args) => (_ctx.deleteBank && _ctx.deleteBank(...args)))
                          }, "delete bank")
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
        ])
      ]),
      _: 1
    }),
    (_ctx.showDeleteAlert)
      ? (_openBlock(), _createBlock(_component_AlertBox, {
          key: 0,
          onClose: _cache[16] || (_cache[16] = $event => (_ctx.showDeleteAlert = false))
        }, {
          header: _withCtx(() => [
            _hoisted_58
          ]),
          body: _withCtx(() => [
            _hoisted_59
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-tertiary",
              onClick: _cache[14] || (_cache[14] = $event => (_ctx.showDeleteAlert = false))
            }, "Cancel"),
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[15] || (_cache[15] = (...args) => (_ctx.yesClicked && _ctx.yesClicked(...args)))
            }, "Delete bank")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}